"use strict";
import { atom, useAtom } from "jotai";
import { useCallback, useEffect } from "react";
export const bottomDockHeightAtom = atom(0);
export const AGENT_PILL_INSET_PX = 20;
export const AGENT_PILL_HEIGHT_PX = 48;
export const AGENT_PILL_CLEARANCE_PX = AGENT_PILL_INSET_PX * 2 + AGENT_PILL_HEIGHT_PX;
export const footerOverlapAtom = atom(0);
export function useRegisterBottomDock() {
  const [, setHeight] = useAtom(bottomDockHeightAtom);
  const onLayout = useCallback(
    (event) => {
      setHeight(event.nativeEvent.layout.height || 0);
    },
    [setHeight]
  );
  useEffect(() => {
    return () => {
      setHeight(0);
    };
  }, [setHeight]);
  return onLayout;
}
export function useReportFooterOverlap(ref) {
  const [, setOverlap] = useAtom(footerOverlapAtom);
  useEffect(() => {
    const element = ref.current;
    if (!element) {
      return void 0;
    }
    let frame = 0;
    const read = () => {
      frame = 0;
      setOverlap(Math.max(0, Math.round(window.innerHeight - element.getBoundingClientRect().top)));
    };
    const schedule = () => {
      frame = frame || requestAnimationFrame(read);
    };
    read();
    window.addEventListener("scroll", schedule, { passive: true });
    window.addEventListener("resize", schedule);
    const observer = new ResizeObserver(schedule);
    observer.observe(element);
    observer.observe(document.body);
    return () => {
      if (frame) {
        cancelAnimationFrame(frame);
      }
      window.removeEventListener("scroll", schedule);
      window.removeEventListener("resize", schedule);
      observer.disconnect();
      setOverlap(0);
    };
  }, [ref, setOverlap]);
}
